import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { ReportModel, ExportModel } from './ReportsModels';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',

    reportSelectListModal = '#reportSelectListModal',
    reportSelectListCloseBtn = '#reportSelectListCloseBtn',
    reportSelectListTable = '#reportSelectListTable',
    exportSelectListTable = '#exportSelectListTable',
    reportSelectListCancelBtn = '#reportSelectListCancelBtn',
    reportSelectListShowBtn = '#reportSelectListShowBtn'

}

declare var GrapeCity: any;
declare var ClassicEditor: any;

export class Reports {
    

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private selectedReportModel: ReportModel;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
        self.createDragEvents();

        $('#reportsMapSelectSaveBtn').on('click', function () {
            events.bus.publish(events.eventExportMapToPng([$('#reportsMapSelectContainer'), function (blob, extent) {
            
                if ((self.selectedReportModel.reportParameters == null)) self.selectedReportModel.reportParameters = [];
                self.selectedReportModel.reportParameters.push({ name: "mapextent", values: [extent.toString()] });

                self.openReportModal(self.selectedReportModel, blob);
                $('#reportsMapSelectContainer').hide();
            }]));
        });
    }

    // ----------------------------------------------------------- //
    //OPEN PANELS
    public openReportModal = (reportModel: ReportModel, insertImage: any = null): void => {
        const self = this;
 
        var data = new FormData();
        data.append('reportID', reportModel.reportID.toString());
        data.append('insertImage', insertImage);
        if (reportModel.reportParameters != undefined && reportModel.reportParameters != null) {
            data.append('reportParameters', JSON.stringify(reportModel.reportParameters));
        }
        //var dto_object = new Blob([JSON.stringify(reportModel)], { type: 'application/json' });

        Utilities.BlockUI();
        $.ajax({
            url: "/Reports/ShowReport",
            type: 'POST',
            processData: false,
            contentType: false,
            data: data,
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, textStatus, request) {
                Utilities.UnBlockUI();
                var cd = request.getResponseHeader("content-disposition").split(';');
                var filename = "report.docx";
                if (cd && cd.length > 1) filename = cd[1].replace('filename=', '').trim();

                var blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                document.removeChild(link);
            },
            error: function (e) {
                Utilities.UnBlockUI();
                console.log(e);
                toastr.error("Failed to create report!");
            }
        });
    }

    public openExportModal = (exportModel: ExportModel): void => {
        const self = this;

        var formData = new FormData();
        formData.append('ExportID', exportModel.exportID.toString());
        if (exportModel.exportParameters != undefined && exportModel.exportParameters != null) {
            formData.append('ExportParameters', JSON.stringify(exportModel.exportParameters));
        }
        
        Utilities.BlockUI();
        $.ajax({
            url: "/Reports/ExportData",
            type: 'POST',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                Utilities.UnBlockUI();
                $('#placeholder-for-modals').html(response);

                Utilities.GetModal('#exportModal', ModalAction.Create);
                $('#exportModalCloseBtn').on('click', function () {
                    Utilities.GetModal('#exportModal', ModalAction.Hide);
                });

            },
            error: function (e) {
                Utilities.UnBlockUI();
                console.log(e);
                toastr.error("Failed to create data export!");
            }
        });
    }

    public showMapReportRectangle = (reportModel: ReportModel): void => {
        var self = this;

        // Calculate rect dimensions and keep the aspect ration
        var mapCanvas = $('#officerMapContainer')[0];

        // Landscape
        if (mapCanvas.getBoundingClientRect().height < mapCanvas.getBoundingClientRect().width) {
            var aspect_ratio = 1000 / 695; // 1000mm/695mm - this is the width/height in the RDLX document
            //reportModel = { ReportName: "RPT_AnnotationMap_Landscape.rdlx" };
            //reportModel = { reportID: 0 };
        }
        else {
            var aspect_ratio = 1700 / 2580; // 17cm/25.8cm - this is the width/height in the RDLX document
            //reportModel = { ReportName: "RPT_AnnotationMap_Portrait.rdlx" };
            //reportModel = { reportID: 0 };
        }

        var height = mapCanvas.getBoundingClientRect().height * 0.9; // Get 90% of the height of the window
        var width = height * aspect_ratio;
        $('#reportsMapSelectContainer').css('width', width + 'px');
        $('#reportsMapSelectContainer').css('height', height + 'px');
        $('#reportsMapSelectContainer').show();
        this.selectedReportModel = reportModel;

        $('#reportsMapSelectCancelBtn').on('click', function () {
            $('#reportsMapSelectContainer').hide();
            self.selectedReportModel = null;
        });
    }

    public openReportOrSelectList = (reportModel: ReportModel, message?: string): void => {
        const self = this;
        
        if (reportModel == null || reportModel.systemType == null) {
            toastr.info("No reports are available for this feature type.");
            return;
        }

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Reports/ReportSelectList', { reportType: reportModel.systemType, message: message }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            
            // Check the number of reports
            var reports = $(jqc.reportSelectListModal + ' [name="reports"]').data("reports");
            // Commenting out so the user always gets the prompt
            //if (reports && reports.reports && reports.reports.length == 1) {
            //    reportModel.reportID = reports.reports[0].reportID;
            //    if (reports.reports[0].promptForMap == true) {
            //        self.showMapReportRectangle(reportModel);
            //    }
            //    else {
            //        self.openReportModal(reportModel);
            //    }
            //}
            //else {
            Utilities.GetModal(jqc.reportSelectListModal, ModalAction.Create);

            // Initialize tables
            (Utilities.GetControl(jqc.reportSelectListTable) as any).bootstrapTable();
            (Utilities.GetControl(jqc.exportSelectListTable) as any).bootstrapTable();
                
            Utilities.GetControl(jqc.reportSelectListShowBtn).on('click', function (evt) {
                var reportTable: any = Utilities.GetControl(jqc.reportSelectListTable);
                var exportTable: any = Utilities.GetControl(jqc.exportSelectListTable);
                let reportRows = reportTable.bootstrapTable('getSelections');
                let exportRows = exportTable.bootstrapTable('getSelections');
                if (reportRows.length < 1 && exportRows.length < 1) {
                    toastr.error("Please select one row!");
                    return;
                }

                if (reportRows.length > 0 && exportRows.length > 0) {
                    toastr.error("Please select one row!");
                    return;
                }

                Utilities.GetModal(jqc.reportSelectListModal, ModalAction.Hide);
                if (reportRows.length > 0) {
                    reportModel.reportID = reportRows[0].reportID;
                    if (reportRows[0].promptForMap == "True" || reportRows[0].promptForMap == "true") {
                        self.showMapReportRectangle(reportModel);
                    }
                    else {
                        self.openReportModal(reportModel);
                    }
                }
                else if (exportRows.length > 0) {
                    var exportModel: ExportModel = exportRows[0];
                    exportModel.exportParameters = reportModel.reportParameters;
                    self.openExportModal(exportModel);
                }
            });

            Utilities.GetControl(jqc.reportSelectListCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.reportSelectListModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.reportSelectListCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.reportSelectListModal, ModalAction.Hide);
            });
            //}
        });
    }

    // ----------------------------------------------------------- //
    // DRAG EVENTS
    private createDragEvents = (): void => {
        var obj = { startPositionX: 0, startPositionY: 0 }; //mouse position
        var scale = 1.0;
        var translate = { x: 0, y: 0 }; //element relative position
        $('#reportsMapSelectContainer').on("mousedown", function (e) {
            var move = $('#reportsMapSelectContainer');
            obj.startPositionX = e.pageX - translate.x;
            obj.startPositionY = e.pageY - translate.y;
            $(document).on("mousemove", function (e) {
                translate.x = e.pageX - obj.startPositionX;
                translate.y = e.pageY - obj.startPositionY;
                move.css({
                    "transform": "translate(" + translate.x + "px," + translate.y + "px)",
                    "transition": "0s"
                });
            });
        });
        $(document).on("mouseup", function () {
            $(this).off("mousemove");
        });
    }
}
    




